// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  presenceId: __t.u64(),
  sessionId: __t.option(__t.u64()),
  positionX: __t.option(__t.f64()),
  positionY: __t.option(__t.f64()),
  positionZ: __t.option(__t.f64()),
  rotationPitch: __t.option(__t.f32()),
  rotationYaw: __t.option(__t.f32()),
  rotationRoll: __t.option(__t.f32()),
  lookX: __t.option(__t.f32()),
  lookY: __t.option(__t.f32()),
  lookZ: __t.option(__t.f32()),
  velocityX: __t.option(__t.f32()),
  velocityY: __t.option(__t.f32()),
  velocityZ: __t.option(__t.f32()),
  sequenceNumber: __t.u64(),
  geoLat: __t.option(__t.f64()),
  geoLon: __t.option(__t.f64()),
  geoElev: __t.option(__t.f64()),
  headingDeg: __t.option(__t.f32()),
  pitchDeg: __t.option(__t.f32()),
  vfovDeg: __t.option(__t.f32()),
  aspect: __t.option(__t.f32()),
};
